"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const notFoundErrorFactory_1 = __importDefault(require("../../../factories/error/notFoundErrorFactory"));
/**
 * Returns custom fleet pricing not found error
 * @returns {object}
 */
const getPriceNotFound = () => {
    return {
        response: (0, notFoundErrorFactory_1.default)('PR404', 'Price could not be loaded'),
    };
};
exports.default = getPriceNotFound;
